import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid2, Typography, useMediaQuery, Tooltip } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';

const SectionButton = ({ icon, label, path, onClick, color, disabled = false }) => {
    const { t: translate } = useTranslation();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const history = useHistory();
    const button = (
        <Grid2
            container
            size={{ xs: 12, md: 3, xl: 1.5 }}
            flexDirection={{ xs: 'row', md: 'column' }}
            justifyContent={{ xs: 'flex-start', md: 'center' }}
            alignItems="center"
            onClick={() => {
                if (disabled) return;
                if (onClick) {
                    onClick();
                }
                if (path) {
                    history.push(path);
                }
            }}
            spacing={2}
            sx={{
                backgroundColor: disabled ? '#ccc' : color,
                color: disabled ? '#13131380' : '#fff',
                p: { xs: '12px', md: '24px' },
                borderRadius: '4px',
                boxShadow: disabled ? 'none' : 'var(--shadow-card)',
                cursor: disabled ? 'not-allowed' : 'pointer',
                transition: 'all .2s ease-in-out !important',
                ...(!disabled && {
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.05)',
                    },
                    '&:active': {
                        transform: 'translateY(-1px) scale(0.99)',
                    },
                }),
                opacity: disabled ? 0.6 : 1,
            }}
        >
            {icon}
            <Typography fontSize={18} fontWeight={600} noWrap>
                {label}
            </Typography>
            {isMobile && <ArrowForwardIos sx={{ marginLeft: 'auto' }} />}
        </Grid2>
    );

    if (disabled) {
        return (
            <Tooltip title={translate('common.soon')} arrow>
                {button}
            </Tooltip>
        );
    }

    return button;
};

export default SectionButton;
